import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProgramService } from '../core/services/program.service';

@Injectable()
export class ProgramIdInterceptor implements HttpInterceptor {
  constructor(private programService: ProgramService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedEndpoint = '/admin/login-2fa';
    if (req.url.includes(excludedEndpoint)) {
      return next.handle(req);
    }
    
    const programId = this.programService.getProgramId();

    const clonedReq = req.clone({
      setHeaders: {
        'X-Program-Id': programId.toString()
      }
    });

    return next.handle(clonedReq);
  }
}

